import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./pages/Home";
import About from "./pages/About";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import SignUp from "./pages/SignUp";
import SignIn from "./pages/SignIn";
import VerifyEmail from "./pages/VerifyEmail";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./contexts/AuthContext";
import { BackgroundTaskProvider } from "./contexts/BackgroundTaskContext";
import { ToastProvider } from "./contexts/ToastContext";
import { UnsavedChangesProvider } from "./contexts/UnsavedChangesContext";
import { StripeProvider } from "./contexts/StripeContext";
import { SubscriptionProvider } from "./contexts/SubscriptionContext";
import { MealPlannerPage } from "./components/MealPlannerPage";
import ProfileManager from "./components/ProfileManager";
import { OtherTools } from "./components/OtherTools";
import { GlobalSubscriptionModal } from "./components/GlobalSubscriptionModal";
import { TokenUsageInitializer } from "./components/TokenUsageInitializer";

function App() {
    return (
        <AuthProvider>
            <StripeProvider>
                <SubscriptionProvider>
                    <ToastProvider>
                        <TokenUsageInitializer />
                        <Router>
                            <BackgroundTaskProvider>
                                <UnsavedChangesProvider>
                                    <div className="App min-h-screen flex flex-col">
                                        <Navbar />
                                        <GlobalSubscriptionModal />

                                        <div className="flex-grow">
                                            <Routes>
                                                {/* Public Routes */}
                                                <Route path="/" element={<Home />} />
                                                <Route
                                                    path="/about"
                                                    element={<About />}
                                                />
                                                <Route
                                                    path="/signup"
                                                    element={<SignUp />}
                                                />
                                                <Route
                                                    path="/signin"
                                                    element={<SignIn />}
                                                />
                                                <Route
                                                    path="/verify-email"
                                                    element={<VerifyEmail />}
                                                />
                                                <Route
                                                    path="/forgot-password"
                                                    element={<ForgotPassword />}
                                                />
                                                <Route
                                                    path="/reset-password"
                                                    element={<ResetPassword />}
                                                />

                                                {/* Protected Routes */}
                                                
                                                {/* Meal Planner Routes */}
                                                <Route
                                                    path="/meal-planner"
                                                    element={
                                                        <ProtectedRoute>
                                                            <div className="min-h-screen bg-gray-50">
                                                                <MealPlannerPage />
                                                            </div>
                                                        </ProtectedRoute>
                                                    }
                                                />
                                                <Route
                                                    path="/meal-planner/:tab"
                                                    element={
                                                        <ProtectedRoute>
                                                            <div className="min-h-screen bg-gray-50">
                                                                <MealPlannerPage />
                                                            </div>
                                                        </ProtectedRoute>
                                                    }
                                                />
                                                
                                                {/* Profile Routes */}
                                                <Route
                                                    path="/profile"
                                                    element={
                                                        <ProtectedRoute>
                                                            <div className="min-h-screen bg-gray-50">
                                                                <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                                                                    <div className="px-4 py-6 sm:px-0">
                                                                        <ProfileManager />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </ProtectedRoute>
                                                    }
                                                />
                                                <Route
                                                    path="/profile/:tab"
                                                    element={
                                                        <ProtectedRoute>
                                                            <div className="min-h-screen bg-gray-50">
                                                                <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                                                                    <div className="px-4 py-6 sm:px-0">
                                                                        <ProfileManager />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </ProtectedRoute>
                                                    }
                                                />
                                                
                                                {/* Other Tools */}
                                                <Route
                                                    path="/other-tools"
                                                    element={
                                                        <ProtectedRoute>
                                                            <OtherTools />
                                                        </ProtectedRoute>
                                                    }
                                                />
                                                
                                                {/* 404 Route */}
                                                <Route
                                                    path="*"
                                                    element={
                                                        <div className="min-h-screen bg-gray-50 flex items-center justify-center">
                                                            <div className="text-center">
                                                                <h1 className="text-2xl font-bold text-gray-900 mb-2">
                                                                    Page Not Found
                                                                </h1>
                                                                <p className="text-gray-600 mb-4">
                                                                    The page you're looking for doesn't exist.
                                                                </p>
                                                                <a
                                                                    href="/"
                                                                    className="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700"
                                                                >
                                                                    Go Home
                                                                </a>
                                                            </div>
                                                        </div>
                                                    }
                                                />
                                            </Routes>
                                        </div>

                                        <Footer />
                                    </div>
                                </UnsavedChangesProvider>
                            </BackgroundTaskProvider>
                        </Router>
                    </ToastProvider>
                </SubscriptionProvider>
            </StripeProvider>
        </AuthProvider>
    );
}

export default App;
